import { Col, Rate, Row, Space, Spin, Image } from "antd";
import React, { FC } from "react";
import styled from "styled-components";
import { ExpertText, MediumHeaderTitle, SmallText } from "../Components/Text3D";
import { Button3D } from "../Components/Button3D";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_SINGLE_PRINTER } from "../Apollo/graphql/Query";
import HeaderComponent from "../Components/HeaderComponents";
import FooterPublic3D from "../Components/FooterPublic3D";
import { getUserId, roundHalf } from "../utils/utilsFunctions";
import { useStoreActions, useStoreState } from "../myStore/index";
import Comments from "../Components/Comments";

const MainWrapper = styled(Row)``;
const ContentWrapper = styled(Col)`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  background: white;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
`;
const TopContent = styled(Col)`
  border-bottom: 1px solid #d8d8d8;
  padding-bottom: 1rem;
`;
const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
`;
const ImageSection = styled.div`
  display: flex;
  height: 360px;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 1px solid #d8d8d8;
  margin: 1rem 0;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
  overflow: hidden;
`;
const ThumbnailImgSection = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  overflow: hidden;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const ThumbnailImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #d8d8d8;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
  height: 122px;
  width: 114px;
`;
const ThumbnailImg = styled(Image)`
  height: 80px;
  width: 70px;
`;
const RightContentSection = styled.div`
  width: 100%;
  padding: 2rem;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;
const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
`;
const SpanX = styled.span`
  margin-left: 1rem;
`;
const RatingDiv = styled.div`
  display: flex;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  height: 50px;
  align-items: center;
`;
const SectionX = styled.section`
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  color: #75706b;
  display: flex;
  align-items: center;
`;
const InfoDiv = styled(Row)`
  padding: 1rem 0;
  border-bottom: 1px solid #d8d8d8;
`;
const RatingSection = styled.div`
  padding: 1rem 0;
`;
const SectionA = styled.div`
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  color: #75706b;
  display: flex;
  align-items: center;
`;

const SinglePrinterPage: FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id?: string }>();
  const userId = getUserId();

  const formsData = useStoreState((state: any) => state.estimates.formsData);
  const setFormsData = useStoreActions(
    (actions: any) => actions.estimates.setFormsData
  );

  const { data, loading } = useQuery(GET_SINGLE_PRINTER, {
    fetchPolicy: "network-only",
    variables: {
      printerId: id,
    },
  });
  
  const handlePrintClick = () => {
    let printerId = data?.printer._id;
    let printerName = data?.printer.name;
    let sellerName = data?.printer.owner.firstName;
    let printerOwnerId = data?.printer.owner._id;
    let price = data?.printer.price;
    let length = data?.printer.length;
    let width = data?.printer.width;
    let height = data?.printer.height;
    let filements = data?.printer.filaments;
    let active = data?.printer?.active;
    let countryCode = data?.printer?.countryCode;
    let postalAddress = data?.printer?.postalAddress;
    let postServiceCode = data?.printer?.postServiceCode;
    setFormsData({
      ...formsData,
      printerId,
      printerOwnerId,
      printerName,
      price,
      sellerName,
      filements,
      length,
      width,
      height,
      active,
      countryCode,
      postServiceCode,
      postalAddress,
    });
    history.push("/design/upload");
  };

  return (
    <Spin spinning={loading}>
      <MainWrapper>
        <HeaderComponent />
        <ContentWrapper
          md={{ span: 20, offset: 2 }}
          sm={{ span: 22, offset: 1 }}
        >
          <TopContent>
            {/* <ExpertText dark>Printers / <a href="main">{printer.name}</a></ExpertText> */}
          </TopContent>
          <Row
            style={{ borderBottom: "1px solid #D8D8D8", paddingBottom: "2rem" }}
          >
            <Col md={{ span: 9 }} sm={{ span: 24 }} style={{ width: "100%" }}>
              <ContentSection>
                <ImageSection>
                  <Image
                    height="100%"
                    width="auto"
                    src={data?.printer.featuredImage}
                    alt=""
                  />
                </ImageSection>
                <ThumbnailImgSection>
                  <Space size="large">
                    {data?.printer?.images &&
                      data.printer.images.map((s, idx) => {
                        return (
                          <ThumbnailImgWrapper key={idx}>
                            <ThumbnailImg src={s} alt=""></ThumbnailImg>
                          </ThumbnailImgWrapper>
                        );
                      })}
                  </Space>
                </ThumbnailImgSection>
              </ContentSection>
            </Col>
            <Col md={{ span: 15 }} sm={{ span: 24 }} style={{ width: "100%" }}>
              <RightContentSection>
                <ContentDiv>
                  <MediumHeaderTitle dark fontSize>
                    <strong>{data?.printer.name}</strong>
                  </MediumHeaderTitle>
                  <ExpertText dark>
                    <strong>Brand:</strong>
                    <SpanX>{data?.printer.brand}</SpanX>
                  </ExpertText>
                  <ExpertText dark>
                    <strong>Printer Dimensions LxWxH:</strong>
                    <SpanX>
                      {data?.printer.length} x {data?.printer.width} x{" "}
                      {data?.printer.height}
                    </SpanX>
                  </ExpertText>
                  <ExpertText dark>
                    <strong>Filaments:</strong>
                    <SpanX>
                      {data?.printer?.filaments &&
                        data?.printer.filaments.map((mat) => (
                          <div>
                            <SpanX>
                              {mat.name === "PLA_PLUS"
                                ? "PLA+"
                                : mat.name.replaceAll("_", " ")}{" "}
                              - ${mat.price} per gram{" "}
                              {`& Colors - ${mat?.colors.toString()}`}
                            </SpanX>
                          </div>
                        ))}
                    </SpanX>
                  </ExpertText>
                  <ExpertText dark>
                    <strong>Location:</strong>
                    <SpanX>
                      {data && data.printer && (
                        <>
                        {data.printer.postalCity ? `${data.printer.postalStreet || '-'},${data.printer.postalCity},${data.printer.postalState},${data.printer.country}` : data.printer.postalAddress || ''}
                        {data.printer.countryCode && ` - (${data.printer.countryCode})`}
                        </>
                      )}
                    </SpanX>
                  </ExpertText>
                  <RatingDiv>
                    <SectionX>
                      <strong style={{ paddingTop: ".2rem" }}>Rate:</strong>
                      <SpanX>
                        {data && data.printer && (
                          <Rate
                            allowHalf
                            defaultValue={roundHalf(
                              data?.printer?.averageStarRating || 0
                            )}
                            disabled
                          />
                        )}
                      </SpanX>
                      <SpanX style={{ paddingTop: ".2rem" }}>
                        {data?.printer?.starRatingCount} Ratings
                      </SpanX>
                    </SectionX>
                  </RatingDiv>
                  <Button3D type="primary" style={{ marginTop: "2rem" }}>
                    {data?.printer?.owner?._id === userId ? (
                      <div
                        onClick={() =>
                          history.push(`/dashboard/add/new/printer/${id}`)
                        }
                      >
                        EDIT
                      </div>
                    ) : (
                      <div onClick={handlePrintClick}>PRINT THIS</div>
                    )}
                  </Button3D>
                </ContentDiv>
              </RightContentSection>
            </Col>
          </Row>

          <InfoDiv>
            <Col>
              <SmallText size small line bold>
                Seller Information:
              </SmallText>
              <SectionX>
                <strong>Profile Name:</strong>
                <SpanX>{`${data?.printer?.owner?.firstName} ${
                  data?.printer?.owner?.lastName
                    ? data.printer.owner.lastName
                    : ""
                }`}</SpanX>
              </SectionX>
            </Col>
          </InfoDiv>

          <RatingSection>
            <SmallText size small line bold>
              Rating & Review of Printer:
            </SmallText>
            <SectionA>
              {data && data.printer && (
                <Rate
                  disabled
                  allowHalf
                  defaultValue={roundHalf(data.printer.averageStarRating || 0)}
                  style={{ paddingRight: "1rem" }}
                />
              )}
              <SpanX>{data?.printer?.starRatingCount} Ratings</SpanX>
            </SectionA>
            <Comments parent={data?.printer} />
          </RatingSection>
        </ContentWrapper>
        <FooterPublic3D />
      </MainWrapper>
    </Spin>
  );
};

export default SinglePrinterPage;
